import { render } from "./InstructorCard.vue?vue&type=template&id=44f136d9&scoped=true"
import script from "./InstructorCard.vue?vue&type=script&lang=js"
export * from "./InstructorCard.vue?vue&type=script&lang=js"

import "./InstructorCard.vue?vue&type=style&index=0&id=44f136d9&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f136d9"]])

export default __exports__